import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import Config from '../config.json';
import axios from 'axios';

const stage = process.env.NAME || 'prod';

const getBaseUrl = (service) => {
    if (service === 'mongoDB' || service === 'mongoDBAuth') {
        var response = `https://api.thexactscope.com/`;
        return response;
    } else if (service === 'elastic') {
        return `https://d1958obtuqe4bs.cloudfront.net/`;
    } else if (service === 'amplify' || service === 'nhtsa' || service === 'app' || service === "logs") {
        return ''
    } else if (service === 'mail-service') {
        return 'https://4txrk5ve3i.execute-api.us-west-2.amazonaws.com/prod/';
    } else if (service === 'stripe') {
        return 'https://dy7oauhne7.execute-api.us-west-2.amazonaws.com/prod/';
    } else if (service === 'subscription') {
        return 'https://dy7oauhne7.execute-api.us-west-2.amazonaws.com/prod/';
    } else {
        var module_url = Config.stage[stage];
        var MODULE_SERVICE = module_url.find(m => m.service === service);
        var MODULE_SERVICE_URL = `https://${MODULE_SERVICE.apiId}.execute-api.${MODULE_SERVICE.region}.amazonaws.com/${stage}/`;
        return MODULE_SERVICE_URL;
    }
}


const rawBaseQuery = fetchBaseQuery({
    baseUrl: '/'
});

const rawBaseElasticQuery = fetchBaseQuery({
    baseUrl: '/',
    prepareHeaders: (headers, { getState }) => {
        headers.set('Content-Type', `application/json`)
        return headers
    }
})

const mongoDBAuth = async (adjustedArgs, api, extraOptions) => {
    return axios.post(adjustedArgs.url, adjustedArgs.body, adjustedArgs.config)
        .then(res => {
            if (res.data.feedback.status === 'success') {
                return res;
            } else {
            }
        })
        .catch(function (error) {
            console.log('error', error)
        })
}

const getLogs = async (args) => {
    return axios.get(`https://vlct3i7u6a.execute-api.us-west-2.amazonaws.com/prod/dotdecode/${args.params.dot}`)
        .then(result => {
            var res = result.data;
            return res;
        })
        .catch(function (error) {
            console.log(error)
        })
}

const appQuery = async (args) => {
    return axios.get(`https://vlct3i7u6a.execute-api.us-west-2.amazonaws.com/prod/dotdecode/${args.params.dot}`)
        .then(result => {

            var response = {};
            var res = result.data;
            if (res.leftFront.dot === args.params.dot) {
                response = {
                    content: res.leftFront.content,
                    recallsCount: res.leftFront.recalls,
                    complaintsCount: res.leftFront.complaints,
                    investigationsCount: res.leftFront.investigations,
                    communicationsCount: res.leftFront.communications,
                };
            } else if (res.leftRear.dot === args.params.dot) {
                response = {
                    content: res.leftRear.content,
                    recallsCount: res.leftRear.recalls,
                    complaintsCount: res.leftRear.complaints,
                    investigationsCount: res.leftRear.investigations,
                    communicationsCount: res.leftRear.communications,
                };
            } else if (res.rightFront.dot === args.params.dot) {
                response = {
                    content: res.rightFront.content,
                    recallsCount: res.rightFront.recalls,
                    complaintsCount: res.rightFront.complaints,
                    investigationsCount: res.rightFront.investigations,
                    communicationsCount: res.rightFront.communications,
                };
            } else if (res.rightRear.dot === args.params.dot) {
                response = {
                    content: res.rightRear.content,
                    recallsCount: res.rightRear.recalls,
                    complaintsCount: res.rightRear.complaints,
                    investigationsCount: res.rightRear.investigations,
                    communicationsCount: res.rightRear.communications,
                };
            } else if (res.spare.dot === args.params.dot) {
                response = {
                    content: res.spare.content,
                    recallsCount: res.spare.recalls,
                    complaintsCount: res.spare.complaints,
                    investigationsCount: res.spare.investigations,
                    communicationsCount: res.spare.communications,
                };
            }

            return response;

        })
        .catch(function (error) {
            console.log(error)
        })
}

const nhtsaQuery = async (args) => {

    switch (args.params.query) {
        case 'model':
            return axios.get(`https://api.nhtsa.gov/tires/bySearch?query=${args.params.model}&dataSet=safetyIssues`)
                .then(res => {
                    return res;
                })
                .catch(function (error) {
                    console.log(error)
                })
        case 'brand':
            return axios.get(`https://api.nhtsa.gov/tires/bySearch?query=${args.params.brand}&dataSet=safetyIssues`)
                .then(res => {
                    return res;
                })
                .catch(function (error) {
                    console.log(error)
                })
        case 'size':
            var size = args.params.size.split('/').join('');
            return axios.get(`https://api.nhtsa.gov/tires/bySearch?query=${size}&dataSet=safetyIssues`)
                .then(res => {
                    return res;
                })
                .catch(function (error) {
                    console.log(error)
                })
        case 'custom':
            return axios.get(`https://api.nhtsa.gov/tires/bySearch?query=${args.params.model}&dataSet=safetyIssues`)
                .then(res => {
                    return res;
                })
                .catch(function (error) {
                    console.log(error)
                })
        default:
            return axios.get(`https://api.nhtsa.gov/tires/bySearch?query=${args.params.model}&dataSet=safetyIssues`)
                .then(res => {
                    return res;
                })
                .catch(function (error) {
                    console.log(error)
                })
    }
}

const twilioQuery = async (adjustedArgs, api, extraOptions) => {
    return axios.post(adjustedArgs.url, adjustedArgs.body)
        .then(res => {
            if (res.data.status === 200) {
                return res;
            } else {
                return res;
            }
        })
        .catch(function (error) {
            return { error: { status: "failed", message: error.response.data.error.description } }
        })
}

const userList = async (adjustedArgs, api, extraOptions) => {
    return axios.post(adjustedArgs.url, adjustedArgs.body)
        .then(res => {
            if (res.data.status === 200) {
                return res;
            } else {
                return res;
            }
        })
        .catch(function (error) {
            return { error: { status: "failed", message: error.response.data.error.description } }
        })
}

const mongoDB = async (adjustedArgs, api, extraOptions) => {
    return axios.get(adjustedArgs.url, {
        withCredentials: true,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
        .then(res => {
            if (res.data.feedback.status === 'success') {
                return res;
            } else {
                return res;
            }
        })
        .catch(function (error) {
            console.log(error)
        })
}

const mongoDBDetails = async (adjustedArgs, api, extraOptions) => {
    return axios.get(adjustedArgs.url, {
        withCredentials: true,
        params: {
            id: adjustedArgs.params
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
        .then(res => {
            if (res.data.feedback.status === 'success') {
                return res;
            } else {
                return res;
            }
        })
        .catch(function (error) {
            console.log(error)
        })
}


const dynamicBaseQuery = async (args, api, extraOptions) => {
    if (args.service === 'twilio') {
        console.log('Reached twilio');
        var res = await twilioQuery(args);
        return res;
    }
    const adjustedUrl = getBaseUrl(args.service) + args.url;
    var adjustedArgs = typeof args === 'string' ? adjustedUrl : { ...args, url: adjustedUrl }

    if (args.service === 'elastic') {
        return rawBaseElasticQuery(adjustedArgs, api, extraOptions)
    } else if (args.service === 'mongoDBAuth') {
        var res = await mongoDBAuth(adjustedArgs, api, extraOptions);
        return res;
    } else if (args.service === 'mongoDB') {
        if (args.params) {
            var res = await mongoDBDetails(adjustedArgs, api, extraOptions);
        } else {
            var res = await mongoDB(adjustedArgs, api, extraOptions);
        }
        return res;
    } else if (args.service === 'amplify') {
        var res = await userList(adjustedArgs, api, extraOptions);
        return res;
    } else if (args.service === 'nhtsa') {
        var res = await nhtsaQuery(args);
        return res;
    } else if (args.service === 'app') {
        var res = await appQuery(args);
        return { data: res };
    } else if (args.service === 'logs') {
        var res = await getLogs(args);
        return { data: res };
    } else if (args.server === 'mail-service') {
        const adjustedUrl = getBaseUrl(args.service) + args.url;
        const adjustedArgs = typeof args === 'string' ? adjustedUrl : { ...args, url: adjustedUrl }
        return rawBaseQuery(adjustedArgs, api, extraOptions);
    } else {
        res = await rawBaseQuery(adjustedArgs, api, extraOptions);
        return res;
    }
}


// initialize an empty api service that we'll inject endpoints into later as needed
export const initSplitApi = createApi({
    baseQuery: dynamicBaseQuery,
    tagTypes: [
        'orgList',
        'roomList', 'roomDetails',
        'userList', 'userDetails',
        'fieldList', 'fieldDetails',
        "blockList", "blockDetails",
        'projectList', 'projectDetails',
        'existingProjectList', 'existingProjectDetails',
        "formTechDetails", 'roleList', 'privateDBDetails', 'privateDBList', 'assignTire',
        "subscriptionDetails",
        "sessionCreate"
    ],
    endpoints: () => ({}),
})